import Dialog from 'components/Dialog';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {action} from 'redux/helpers';
import history from 'redux/history';
import LoginForm from '../LoginForm';
import {loginTypes} from '../redux';
import {ReactFChildrenProps} from 'types/react/ReactFChildrenProps';

type Props = {
   userName?: string;
   isAuthenticated?: boolean;
   allowChangeUser?: boolean;
};

const LoginDialog: ReactFChildrenProps<Props> = ({userName, isAuthenticated, allowChangeUser}) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();
   const logout = React.useCallback(() => {
      dispatch(action(loginTypes.LOGOUT.SUCCESS));
      history.push('/');
   }, [dispatch]);

   return isAuthenticated ? null : (
      <Dialog maxWidth="sm" header={t('Your session has expired, please login.')} close={logout}>
         <LoginForm userName={userName} allowChangeUser={allowChangeUser} />
      </Dialog>
   );
};

export default React.memo(LoginDialog);
